// Every AegisName that can satisfy a combo condition: each equipped item plus
// ALL of its card / enchant slots (not just slot 0). Enchants live in card
// slots, so this lets enchants in any slot trigger combos.
export function collectComboAegisNames(inventory) {
	const names = []
	Object.values(inventory).forEach((item) => {
		if (!item) return
		if (item.AegisName) names.push(item.AegisName)
		if (Array.isArray(item.CardSlots)) {
			item.CardSlots.forEach((slot) => {
				if (slot && slot.AegisName) names.push(slot.AegisName)
			})
		}
	})
	return names
}
